<template>
  <div class="posts-collection">
    <AccentCardsWrapp
      :area="area"
      :articles="serverPosts"
      @on-click-item="onClickAccentCard"
    />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import type { TArticle } from '~/types/common';
  import AccentCardsWrapp from '~/components/AccentCardsWrapp.vue';
  import { preparePosts } from '~/utils/posts-collection.widget';
  import { shuffleArray } from '~/utils/arrays';
  import getSlugFromUrl from '~/utils/getSlugFromUrl';

  export default defineNuxtComponent({
    name: 'PostsCollection',
    components: {
      AccentCardsWrapp,
    },

    inject: {
      areaAnalytics: {
        default() {
          return () => '';
        },
      },

      eventName: {
        default() {
          return () => 'Выбор материала_посты коллекция постов';
        },
      },
    },

    props: {
      posts: {
        type: Array as PropType<TArticle[]>,
        default() {
          return [];
        },
      },

      title: {
        type: String as PropType<string>,
        default: '',
      },
    },

    async setup(props) {
      const { $logger } = useNuxtApp();
      const injectedArea = inject<() => string>('area', () => '');
      const area = computed(() => injectedArea());
      const serverPosts = computed(() => preparePosts(props.posts, area.value));

      $logger('posts-collection', serverPosts.value);

      return {
        serverPosts,
        area,
      };
    },

    computed: {
      checkPosts(): boolean {
        return this.posts.length >= 4 || (this.posts.length === 1 && this.area === 'sidebar');
      },

      currentSlug(): string {
        return getSlugFromUrl(useRoute().fullPath);
      },
    },

    methods: {
      shuffleArray,

      // Функция для аналитики клика на карточку поста
      onClickAccentCard(_article: TArticle) {
        // const eventName = this.eventName();
        // const slugRefferer = getSlugFromUrl(article.url);
      },
    },
  });
</script>
